import { createUriFiles } from 'owa-attachment-file-types';
import { ClientAttachmentId } from 'owa-client-ids';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import { ComposeViewState } from 'owa-mail-compose-store';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import createAttachments from 'owa-mail-compose-store/lib/utils/createAttachments';
import {
    infoBarAddHandler,
    infoBarRemoveHandler,
} from 'owa-mail-compose-store/lib/utils/infoBarHandlers';

export default function addFile(
    viewState: ComposeViewState,
    attachmentName: string,
    uri: string,
    isInline: boolean
): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        let hasProcessed = false;
        const handler = infoBarAddHandler(viewState);

        const attachmentErrorHandler = (
            messageId: string,
            infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
        ) => {
            handler(messageId, infoBarMessageViewStateCreator);
            if (!hasProcessed) {
                hasProcessed = true;
                reject({ errorType: 'UploadError', id: messageId });
            }
        };

        const onFinish = (attachmentId: ClientAttachmentId) => {
            if (!hasProcessed) {
                hasProcessed = true;
                resolve(attachmentId.Id);
            }
        };

        try {
            const file = createUriFiles([{ name: attachmentName, url: uri }]);
            const composePlugins = findComposePlugins(viewState);
            const inlineImagePlugin = composePlugins.inlineImagePlugin;
            const isPlainText = viewState.bodyType != 'HTML';
            const processInlineImageBeforeUpload = isPlainText
                ? null
                : inlineImagePlugin.processInlineImageBeforeUpload.bind(inlineImagePlugin);

            createAttachments(
                file,
                viewState,
                {
                    isInline,
                    isHiddenInline: true,
                    shouldShare: false,
                },
                processInlineImageBeforeUpload,
                attachmentErrorHandler,
                infoBarRemoveHandler(viewState),
                onFinish
            );
        } catch (err) {
            reject({ errorType: 'UploadError' });
        }
    });
}
